import { makeHeaders } from "@coworker/app/src/components/RoomSettings/tools";
import { getTokenAsync } from "@coworker/app/src/hooks/API/getAuthToken";
import { TASKS_SERVICE_URL } from "@coworker/app/src/hooks/API/tasks.service.helper";
import { FullTask } from "../types/FullTask";

export const getTask = async (taskId: string) => {
  const token = await getTokenAsync();
  if (!token || typeof token !== "string") {
    throw new Error("Could not get a token.");
  }
  const response = await fetch(
    `${TASKS_SERVICE_URL}/v1/tasks/by_ids?ids=${taskId}`,
    {
      method: "GET",
      headers: makeHeaders(token),
    }
  );

  if (!response.ok) {
    throw new Error("Network response was not ok.");
  }

  const data = await response.json();
  const task = data?.tasks[0] ? (data.tasks[0] as FullTask) : null;
  return task;
};
